/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {BROWSER_GLOBALS_PROVIDERS as ɵc,DocumentRef as ɵb,WindowRef as ɵa} from './lib/utils/browser-globals';